import { createReducer, on } from '@ngrx/store';

import * as MediaFilesActions from '../actions/live-media-files-view.actions';
import * as SegmentsActions from '../actions/live-segments.actions';

export enum MediaFilesViewType {
  Files = 'files',
  Segments = 'segments'
}

export interface IMediaFilesViewState {
  view: MediaFilesViewType;
}

const initialState: IMediaFilesViewState = {
  view: MediaFilesViewType.Files
};

export const reducer = createReducer(
  initialState,
  on(MediaFilesActions.setView, (state, { view }) => ({
    ...state,
    view
  })),
  on(SegmentsActions.searchStarted, state => ({
    ...state,
    view: MediaFilesViewType.Segments
  })),
  on(SegmentsActions.clearSearch, state => ({
    ...state,
    view: MediaFilesViewType.Files
  }))
);
